(function () {
  function getFormAction(form) {
    var action = form.getAttribute('action') || '/contact';

    try {
      var url = new URL(action, window.location.origin);
      return url.pathname + url.search;
    } catch (error) {
      return action.split('#')[0];
    }
  }

  function getCaptchaField(form) {
    if (!form) return null;

    if (form.elements && form.elements['h-captcha-response']) {
      return form.elements['h-captcha-response'];
    }

    return form.querySelector('[name="h-captcha-response"]');
  }

  function waitForCaptchaToken(form, maxMs) {
    var timeout = maxMs || 5000;

    return new Promise(function (resolve, reject) {
      var startedAt = Date.now();

      (function poll() {
        var captchaField = getCaptchaField(form);

        if (captchaField && captchaField.value) {
          resolve(captchaField.value);
          return;
        }

        if (Date.now() - startedAt >= timeout) {
          reject(new Error('captcha_missing'));
          return;
        }

        window.setTimeout(poll, 50);
      })();
    });
  }

  function buildFormBody(form) {
    var body = new FormData(form);
    var captchaField = getCaptchaField(form);

    if (captchaField && captchaField.value) {
      body.set('h-captcha-response', captchaField.value);
    }

    return body;
  }

  function isSuccessResponse(response) {
    return response.ok && response.url && response.url.indexOf('customer_posted=true') !== -1;
  }

  function isSuccessUrl(url) {
    return url && url.indexOf('customer_posted=true') !== -1;
  }

  function isSuccessHtml(html) {
    return html && html.indexOf('customer_posted=true') !== -1;
  }

  function setFeedback(form, type, message) {
    var feedback = form.querySelector('.hero-newsletter-form__feedback');
    var successTemplate = form.querySelector('.hero-newsletter-form__success-template');
    if (!feedback) return;

    feedback.classList.remove('is-success', 'is-error', 'newsletter-form__message--success');
    feedback.innerHTML = '';

    if (!type) {
      feedback.hidden = true;
      return;
    }

    feedback.hidden = false;

    if (type === 'success') {
      feedback.classList.add('is-success', 'newsletter-form__message--success');
      feedback.innerHTML = successTemplate ? successTemplate.innerHTML : message || '';
      return;
    }

    feedback.classList.add('is-error');
    feedback.textContent = message || '';
  }

  function submitViaFetch(form) {
    return waitForCaptchaToken(form).then(function () {
      return fetch(getFormAction(form), {
        method: 'POST',
        body: buildFormBody(form),
        credentials: 'same-origin',
        redirect: 'follow',
      }).then(function (response) {
        if (isSuccessResponse(response)) return;
        throw new Error('subscribe_failed');
      });
    });
  }

  function submitViaHiddenIframe(form) {
    return new Promise(function (resolve, reject) {
      var iframeName = 'heroNewsletterFrame_' + Date.now();
      var iframe = document.createElement('iframe');
      var settled = false;
      var hasSubmitted = false;

      iframe.name = iframeName;
      iframe.hidden = true;
      iframe.style.cssText = 'display:none;width:0;height:0;border:0';
      document.body.appendChild(iframe);

      var timeoutId = window.setTimeout(function () {
        if (settled) return;
        settled = true;
        cleanup();
        reject(new Error('iframe_timeout'));
      }, 15000);

      function cleanup() {
        window.clearTimeout(timeoutId);
        form.removeAttribute('target');
        iframe.removeEventListener('load', onLoad);
        if (iframe.parentNode) iframe.parentNode.removeChild(iframe);
      }

      function finish(error) {
        if (settled) return;
        settled = true;
        cleanup();
        if (error) reject(error);
        else resolve();
      }

      function onLoad() {
        if (!hasSubmitted) return;

        try {
          var url = iframe.contentWindow.location.href;

          if (!url || url === 'about:blank') return;

          if (isSuccessUrl(url)) {
            finish(null);
            return;
          }

          var html = iframe.contentDocument.documentElement.innerHTML;

          if (isSuccessHtml(html)) {
            finish(null);
            return;
          }

          if (
            html.indexOf('Missing CAPTCHA token') !== -1 ||
            html.indexOf('aria-invalid="true"') !== -1
          ) {
            finish(new Error('subscribe_failed'));
            return;
          }

          finish(new Error('subscribe_failed'));
        } catch (error) {
          // Preview / production may redirect to another origin after a successful POST.
          finish(null);
        }
      }

      iframe.addEventListener('load', onLoad);
      form.setAttribute('target', iframeName);
      hasSubmitted = true;
      form.submit();
    });
  }

  function submitHeroNewsletterForm(form) {
    if (form.dataset.heroNewsletterSubmitting === 'true') return;

    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    var submitBtn = form.querySelector('[data-hero-newsletter-submit]');
    var submitSpan = submitBtn ? submitBtn.querySelector('span') : null;
    var originalText = submitSpan ? submitSpan.textContent : '';
    var successMessage = form.dataset.successMessage || 'Thanks for subscribing';
    var errorMessage = form.dataset.errorMessage || 'Unable to subscribe. Please try again.';
    var requestId = Date.now();
    form.dataset.heroNewsletterRequestId = String(requestId);

    form.dataset.heroNewsletterSubmitting = 'true';
    if (submitBtn) submitBtn.disabled = true;
    if (submitSpan) submitSpan.textContent = '...';
    setFeedback(form, null);

    var finishRequest = function () {
      if (form.dataset.heroNewsletterRequestId !== String(requestId)) return;
      form.dataset.heroNewsletterSubmitting = 'false';
      if (submitBtn) submitBtn.disabled = false;
      if (submitSpan) submitSpan.textContent = originalText;
    };

    var runSubmit = function () {
      submitViaFetch(form)
        .catch(function () {
          return submitViaHiddenIframe(form);
        })
        .then(function () {
          if (form.dataset.heroNewsletterRequestId !== String(requestId)) return;
          setFeedback(form, 'success', successMessage);
        })
        .catch(function () {
          if (form.dataset.heroNewsletterRequestId !== String(requestId)) return;
          setFeedback(form, 'error', errorMessage);
        })
        .finally(finishRequest);
    };

    if (window.Shopify && window.Shopify.captcha && typeof window.Shopify.captcha.protect === 'function') {
      window.Shopify.captcha.protect(form, runSubmit);
    } else {
      runSubmit();
    }
  }

  function bindHeroNewsletterForm(form) {
    if (!form || form.dataset.heroNewsletterBound === 'true') return;
    form.dataset.heroNewsletterBound = 'true';

    if (window.Shopify && window.Shopify.captcha && typeof window.Shopify.captcha.protect === 'function') {
      window.Shopify.captcha.protect(form);
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      submitHeroNewsletterForm(form);
    });

    var submitBtn = form.querySelector('[data-hero-newsletter-submit]');
    if (submitBtn) {
      submitBtn.addEventListener('click', function () {
        submitHeroNewsletterForm(form);
      });
    }

    form.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter') return;
      if (event.target && event.target.name === 'contact[email]') {
        event.preventDefault();
        submitHeroNewsletterForm(form);
      }
    });
  }

  function bindAllHeroNewsletterForms(root) {
    (root || document).querySelectorAll('.newsletter-form-hero-banner').forEach(bindHeroNewsletterForm);
  }

  bindAllHeroNewsletterForms();

  document.addEventListener('shopify:section:load', function (event) {
    bindAllHeroNewsletterForms(event.target);
  });
})();
